import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Link, browserHistory } from 'react-router';
import PieChart from 'react-simple-pie-chart';
import InlineSVG from 'svg-inline-react';
import ReactTooltip from 'react-tooltip';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton';
import Divider from 'material-ui/Divider';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import EditIcon from 'material-ui/svg-icons/content/create';
import DeleteIcon from 'material-ui/svg-icons/action/delete';

import ContactCard from '../ContactCard/ContactCard';
import classes from './ActivityTableDetail.scss';
import widthClasses from './ColumnWidths.scss';
import icTasks from '../../assets/ic-tasks.svg';
import icFiles from '../../assets/ic-files.svg';
import { Dialog, FlatButton } from 'material-ui';
import localizedType from '../../helpers/localizedType';
import urlFromType from '../../helpers/urlFromType';
import striptags from 'striptags';

export class ActivityTableDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
      alert: null,
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    let rerender = false;

    if (
      Object.keys(nextProps.activity).length !==
      Object.keys(this.props.activity).length
    ) {
      rerender = true;
    }

    if (
      Object.keys(nextProps.responsibleUser).length !==
      Object.keys(this.props.responsibleUser).length
    ) {
      rerender = true;
    }

    if (!_.isEqual(this.props.responsibleUser, nextProps.responsibleUser)) {
      rerender = true;
    }

    if (
      typeof nextProps.responsibleUser !== 'undefined' &&
      typeof nextProps.responsibleUser.avatar !== 'undefined' &&
      nextProps.responsibleUser.avatar !== null
    ) {
      if (
        nextProps.responsibleUser.avatar !== this.props.responsibleUser.avatar
      ) {
        return true;
      }
    }

    if (this.state.expanded !== nextState.expanded) {
      rerender = true;
    }

    if (this.state.alert !== nextState.alert) {
      rerender = true;
    }

    if (this.props.mode !== nextProps.mode) {
      return true;
    }

    return rerender;
  }

  handleAlertClose = () => {
    this.setState({
      alert: null,
    });
  };

  getMenuItems = menulocation => {
    const items = [];

    items.push(
      <MenuItem
        key={`activity_context_${menulocation}_${this.props.activity.id}_edit`}
        primaryText="Bearbeiten"
        leftIcon={<EditIcon />}
        onTouchTap={e => {
          this.props.setActivityForm(this.props.activity.id);
          this.props.closeContextMenu();
        }}
      />,
    );

    items.push(
      <Divider
        key={`activity_context_${menulocation}_${this.props.activity.id}_divider`}
      />,
    );
    items.push(
      <MenuItem
        primaryText="Aktivität löschen"
        leftIcon={<DeleteIcon className="svg-icon-primary svg-icon-warning" />}
        key={`activity_context_${menulocation}_${this.props.activity.id}_delete`}
        className="menu-primary"
        onClick={() => {
          this.props.closeContextMenu();
          this.setState({
            alert: (
              <Dialog
                actions={[
                  <FlatButton
                    label="Abbrechen"
                    primary
                    onTouchTap={this.handleAlertClose}
                  />,
                  <FlatButton
                    label="Löschen"
                    primary
                    onTouchTap={() => {
                      this.handleAlertClose();
                      this.props.deleteActivity(this.props.activity.id);
                      browserHistory.push('/activity');
                    }}
                  />,
                ]}
                modal={false}
                open
                onRequestClose={this.handleAlertClose}
              >
                Aktivität wirklich löschen?
              </Dialog>
            ),
          });
        }}
      />,
    );
    return items;
  };

  renderLinkedWith = () => {
    const activity = this.props.activity;
    if (
      typeof activity.linkedWith !== 'undefined' &&
      activity.linkedWith.id.length
    ) {
      return (
        <Link
          to={urlFromType(activity.linkedWith.type, activity.linkedWith.id)}
        >
          {activity.linkedWith.name} ({localizedType(activity.linkedWith.type)})
        </Link>
      );
    }
    return null;
  };

  render() {
    const activity = this.props.activity;
    const mode = this.props.mode;
    let note;
    const openClass = this.state.expanded ? classes.expanded : null; // {activity.notes.replace(/<(?:.|\n)*?>/gm, ' ')}
    let text = <div />;
    if (this.state.expanded) {
      text = (
        <div
          className={classes.content}
          dangerouslySetInnerHTML={{
            __html: activity.notes,
          }}
        />
      );
    } else {
      text = (
        <div className={classes.content}>
          {striptags(activity.notes, [], ' ')}
        </div>
      );
    }
    if (
      mode === 'detail' &&
      activity.notes !== null &&
      typeof activity.notes !== 'undefined' &&
      activity.notes.length !== 0 &&
      striptags(activity.notes).length !== 0
    ) {
      note = (
        <div
          className="row"
          onClick={() => {
            this.setState({
              expanded: !this.state.expanded,
            });
          }}
        >
          <div
            className={`${classes.cell} ${classes.notes} ${openClass} ${widthClasses.note}`}
          >
            {text}
          </div>
        </div>
      );
    }

    const modeClass = mode === 'detail' ? classes.detail : classes.table;

    const tasksCompleted = activity.tasks_completed
      ? activity.tasks_completed
      : 0;

    const tasksTotal = activity.tasks_total ? activity.tasks_total : 0;

    const tasksLength = tasksTotal - tasksCompleted;
    const user = this.props.responsibleUser;
    let userCard = activity.responsible_user;
    if (typeof this.props.responsibleUser !== 'undefined') {
      userCard = (
        <ContactCard
          id={user.id}
          name={user.name}
          avatar={user.avatar}
          type="staff"
          displayType="imageOnly"
        />
      );
    }
    let particpants = 0;
    if (typeof activity.staff !== 'undefined') {
      particpants += activity.staff.length;
    }
    if (typeof activity.persons !== 'undefined') {
      particpants += activity.persons.length;
    }

    const tasksText = `${tasksCompleted}/${tasksTotal} Aufgaben erledigt`;
    const iconTasks = activity.tasks.length ? (
      <InlineSVG src={icTasks} data-tip={tasksText} />
    ) : null;

    const filesText = `${activity.files.length} Dateien hochgeladen`;
    const iconFiles =
      typeof activity.files !== 'undefined' && activity.files.length ? (
        <InlineSVG src={icFiles} data-tip={filesText} />
      ) : null;
    let piechart = null;
    if (activity.tasks_total) {
      const statusTooltipId = `activity_${activity.id}_status_tooltip`;
      piechart = (
        <div data-tip={tasksText} data-for={statusTooltipId}>
          <PieChart
            slices={[
              {
                color: '#fff',
                value: tasksLength,
              },
              {
                color: '#64dc14',
                value: tasksCompleted,
              },
            ]}
          />
          <ReactTooltip
            id={statusTooltipId}
            className={classes.tooltip}
            place="bottom"
            type="dark"
            effect="solid"
            html
          />
        </div>
      );
    }
    const participantsTooltipId = `${activity.id}-tooltip`;
    let participantsTooltip = null;
    if (
      typeof activity.participatingPeople !== 'undefined' &&
      activity.participatingPeople.length
    ) {
      participantsTooltip = activity.participatingPeople.join('<br />');
    }
    let participantsHtml = null;
    if (particpants > 0) {
      participantsHtml = (
        <div
          className={classes.participants}
          data-tip={participantsTooltip}
          data-for={participantsTooltipId}
        >
          {particpants > 0 ? `+ ${particpants}` : ''}
        </div>
      );
    }
    let date = (
      <span className={classes.date}>
        {activity.extraInfo.startDate}
        <br />
        {activity.extraInfo.startTime}
      </span>
    );
    if (
      activity.extraInfo.sameDay &&
      activity.extraInfo.startTime !== activity.extraInfo.endTime
    ) {
      date = (
        <span className={classes.date}>
          {activity.extraInfo.startDate} <br />
          {activity.extraInfo.startTime} - {activity.extraInfo.endTime}
        </span>
      );
    } else if (!activity.extraInfo.sameDay) {
      date = (
        <span className={classes.date}>
          {activity.extraInfo.startDate} {activity.extraInfo.startTime} -<br />
          {activity.extraInfo.endDate} {activity.extraInfo.endTime}
        </span>
      );
    }
    return (
      <div
        className={classes.rowDiv}
        onContextMenu={e =>
          this.props.openContextMenu(e, this.getMenuItems('contextmenu'))
        }
      >
        <div className={`row ${classes.firstRow} ${modeClass}`}>
          <div
            className={`${classes.cell} ${classes.titleCell} ${widthClasses.title}`}
          >
            <Link to={`/activity/${activity.id}`}>{activity.title}</Link>
            {iconFiles}
            {iconTasks}
          </div>
          <div
            className={`${classes.cell} ${widthClasses.linked} hidden-phone`}
          >
            {this.renderLinkedWith()}
          </div>
          <div
            className={`${classes.cell} ${widthClasses.communication} hidden-phone`}
          >
            {activity.extraInfo.communicationString}
          </div>
          <div
            className={`${classes.cell} ${classes.dateCell} ${widthClasses.date} hidden-phone`}
          >
            {date}
          </div>
          <div
            className={`${classes.cell} ${classes.pieChart} ${widthClasses.pie} hidden-phone`}
          >
            {piechart}
          </div>
          <div
            className={`${classes.cell} ${classes.userCell} ${widthClasses.users} hidden-phone`}
          >
            {userCard}
            {participantsHtml}
          </div>
          <div
            className={`${classes.cell} ${classes.buttonCell} ${widthClasses.actions}`}
          >
            <IconMenu
              iconButtonElement={
                <IconButton>
                  <MoreVertIcon />
                </IconButton>
              }
              anchorOrigin={{
                horizontal: 'right',
                vertical: 'top',
              }}
              targetOrigin={{
                horizontal: 'right',
                vertical: 'top',
              }}
            >
              {this.getMenuItems('iconmenu')}
            </IconMenu>
          </div>
        </div>
        {note}
        <ReactTooltip
          id={participantsTooltipId}
          className={classes.tooltip}
          place="bottom"
          type="dark"
          effect="solid"
          html
        />
        {this.state.alert}
      </div>
    );
  }
}
ActivityTableDetail.propTypes = {
  activity: PropTypes.object,
  responsibleUser: PropTypes.object, // compact: PropTypes.bool,
  mode: PropTypes.string,
  setActivityForm: PropTypes.func,
  deleteActivity: PropTypes.func,
  openContextMenu: PropTypes.func,
  closeContextMenu: PropTypes.func,
};
ActivityTableDetail.defaultProps = {
  responsibleUser: {},
};
export default ActivityTableDetail;



// WEBPACK FOOTER //
// ./src/components/ActivityTableDetail/ActivityTableDetail.js